import { render, staticRenderFns } from "./BynderPublishModal.vue?vue&type=template&id=076c653d"
import script from "./BynderPublishModal.vue?vue&type=script&lang=js"
export * from "./BynderPublishModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports